module.exports = __webpack_public_path__ + "img/404.1d87917a.svg";